import _l from "@/utils/localization";
export const NAME_FIELD = {
    key: "name",
    label: _l("Name"),
    sortable: true,
};
export const DESCRIPTION_FIELD = {
    key: "description",
    label: _l("Description"),
    sortable: true,
};
export const TYPE_FIELD = {
    key: "type",
    label: _l("Type"),
    sortable: true,
};
export const TEMPLATE_FIELD = {
    key: "template",
    label: _l("From Template"),
    sortable: true,
};
